// import { Jsonp } from '@angular/http';

export interface JsonDatatypeInterface {
  data?: {};
}

export class JsonDatatypeClass implements JsonDatatypeInterface {
  data?: {};
}

export interface BaseRuleNodeInterface {
  negation_logic: string;
  rule_type: string;
  rule_name: string;
}

/** Generic Version currently not in use */
export interface RuleNodeConditionalFilterGenericInterface<T extends BaseRuleNodeInterface>  {
  top_level_logic: string; 
  negation_logic: string;
  rules: T[];
}

export interface RuleNodeConditionalFilterInterface {
  top_level_logic: string;
  negation_logic: string; 
  rules: any[];
}

export interface HdrDocConditionalFilterInterface {
  hdr_doc_filter: RuleNodeConditionalFilterInterface;
}

export interface MultiLineDocFilterInterface {
  multi_line_doc_filter: RuleNodeConditionalFilterInterface;
}

export interface SingleLineDocFilterInterface {
  single_line_doc_filter: RuleNodeConditionalFilterInterface;
}

export interface PriceOperatorValueInterface {
  price_source: string; 
  operator: string; 
  value: number; 
  pricing_scheme_guid?: string;
  point_ccy_guid: string;
  validity_period_days:number;
  pricing_model_guid?: string;
}

export interface CommissionTreatmentNodeInterface {
  commission: PriceOperatorValueInterface;
}

export interface MembershipPointsTreatmentNodeInterface {
  membership_points: PriceOperatorValueInterface;
}

export interface TreatmentNodeInterface
  extends CommissionTreatmentNodeInterface,
    MembershipPointsTreatmentNodeInterface {}


export interface TreatmentJsonInterface {
  treatments: TreatmentNodeInterface[];
}

export interface DiagnosisJsonInterface {
  diagnosis: string[];
}

export interface MultiMemberPointsJson {
    addons: MemberPointAssignmentStructuredWrapper[];
}

export class MemberPointAssignmentStructuredWrapper {
    point_amount: number;
    point_type: string;
    point_currency: string;
}

export class shared_audit_trail_json {
  old_data: JsonDatatypeInterface;
  new_data: JsonDatatypeInterface;
  delete_data: JsonDatatypeInterface;
}